(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["alert-bar"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const slider = document.getElementById('alertBarSlider');
  if (!slider) return;

  const slides = slider.children;
  let current = 0;

  const autoSlide = slider.dataset.autoSlide === 'true';
  const interval = parseInt(slider.dataset.slideInterval || '4000', 10);

  function showNextSlide() {
    current = (current + 1) % slides.length;
    slider.style.transform = `translateX(-${current * 100}%)`;
  }

  if (slides.length > 1 && autoSlide) {
    setInterval(showNextSlide, interval);
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["products-right"] && !Shopify.designMode) return;
  try {
    
const slidesContainer = document.querySelector('#lookbookSlider .slides-container');
const slides          = slidesContainer.children;
const dots            = document.querySelectorAll('.lookbook-dot');
const counter         = document.getElementById('lookbookCounter');
let current           = 0;

// move the reel
function showSlide(index) {
  slidesContainer.style.transform = `translateY(-${index * 100}%)`;
  dots.forEach((dot, i) => dot.classList.toggle('active', i === index));
  counter.innerText = index + 1;
  current = index;
}

// dot navigation
dots.forEach(dot =>
  dot.addEventListener('click', () => showSlide(+dot.dataset.index))
);

// 3-second reel speed
let autoSlide = setInterval(
  () => showSlide((current + 1) % slides.length),
  4000
);

// pause on hover
const wrapper = document.getElementById('lookbookSlider');
wrapper.addEventListener('mouseenter', () => clearInterval(autoSlide));
wrapper.addEventListener('mouseleave', () => {
  autoSlide = setInterval(
    () => showSlide((current + 1) % slides.length),
    3000
  );
});

// re-position on resize
window.addEventListener('resize', () => showSlide(current));

  } catch(e) { console.error(e); }
})();
})();
